export enum HrCapitalFormationDistributionModalMode {
  VIEW = "view",
  EDIT = "edit",
}
